import { Directive, ElementRef, Input } from "@angular/core";
import * as clampLib from "text-overflow-clamp";
var TextOverflowClampDirective = /** @class */ (function () {
    function TextOverflowClampDirective(el) {
        this.el = el;
    }
    TextOverflowClampDirective.prototype.ngAfterViewInit = function () {
        clampLib(this.el.nativeElement, this.lines);
    };
    TextOverflowClampDirective.decorators = [
        { type: Directive, args: [{ selector: "[clamp]" },] },
    ];
    /** @nocollapse */
    TextOverflowClampDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    TextOverflowClampDirective.propDecorators = {
        'lines': [{ type: Input, args: ["clamp",] },],
    };
    return TextOverflowClampDirective;
}());
export { TextOverflowClampDirective };
//# sourceMappingURL=clamp.directive.js.map